import { useState, useEffect } from 'react'
import { MissionTriggerModel } from '../../../../domain/model/mission-trigger.model'
import { useGame } from '../../../contexts'
import { getAssetUrl } from '../../../utils/assets_helpers'
import { getTeam } from '../../../utils/team_helpers'
import { Flex } from '../../ui/components'
import { SimpleButton } from '../../ui/components/buttons/simple'
import {
  Container,
  Blur,
  Footer,
  Description,
  Image, MissionApprovalWrapper
} from './styles'
import { GameState } from '../../../../domain/enum/game-state.enum'
import MissionApproval from '../../mission_approval'
import { getLocalStorage } from '../../../utils/storage_helpers'

type IAction = {
  action: () => void;
}

type Props = {
  isShowing: boolean;
  missionTrigger: MissionTriggerModel;
  action: IAction;
}

const Feedback = ({ missionTrigger, isShowing, action }: Props) => {
  const team = getTeam()
  const { game } = useGame()
  const [gameInApproval, setGameInApproval] = useState(false)
  const [mission, setMission] = useState<any>(null)
  const [openModalReview, setOpenModalReview] = useState(false)

  let feedBackText = missionTrigger?.highlightedText
  if (team) {
    feedBackText = feedBackText?.replace('{{NomeDoTime}}', team.name)
  }

  useEffect(() => {
    if (game?.gameState === GameState.APPROVAL) {
      setGameInApproval(true)
    }
  }, [game])

  useEffect(() => {
    setMission(getLocalStorage('currentMission'))
  }, [])

  function buttonEnable () {
    console.log('TriggerReview')
  }

  function handleAction () {
    setOpenModalReview(false)
    action.action()
  }

  return (
    <>
      <div style={{ position: 'relative', zIndex: 99999 }}>
      {gameInApproval && missionTrigger && isShowing && (
          <MissionApprovalWrapper>
            <MissionApproval
              isShowing={true}
              color={game?.baseColor}
              mission={mission}
              onAction={buttonEnable}
              approved={false}
              topButtonContainer={'calc(100% - -45vh)'}
              topModalContainer={50}
              isMissionTrigger={true}
              missionTrigger={missionTrigger}
              openModal={openModalReview}
              setOpenModal={setOpenModalReview}
            />
          </MissionApprovalWrapper>
      )}
      </div>
    <Container $isOpen={isShowing}>
      <Blur />

      <Footer border={missionTrigger.color}>
        {missionTrigger.image && <Image src={getAssetUrl('image', missionTrigger.image)}/>}

        <Flex w={'220px'} />

        <Description>
          {feedBackText}
        </Description>

        <Flex w={'220px'} justifyContent="flex-end">
          <SimpleButton
            onAction={handleAction}
            bg={missionTrigger.buttonColor}
            color={missionTrigger.buttonTextColor}
          >
            {missionTrigger.buttonText}
          </SimpleButton>
        </Flex>
      </Footer>
    </Container>
    </>
  )
}

export default Feedback
